
import AppButton from "./LoginButton.vue";
import AppSection from "./LoginSection.vue";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			value: ""
		};
	},
	methods: {
		extendValidate(){
			this.isValid = false;
			if (/^[0-9]{6}$/.test(this.value)){
				this.isValid = true;
			}
			if (/^[0-9]{10}$/.test(this.value)){
				this.isValid = true;
			}
		},
		onInput(val:string){
			let oldValue = this.value;
			this.value = val;
			if (!/^[0-9]{0,10}$/.test(val)){
				this.$nextTick(()=>{
					this.value = oldValue;
				});
			}
		},
		submit(){
			this.validate();
			if (!this.isValid) return;
			this.$emit("login", this.value.toString());
		},
		cancel(){
			this.$emit("cancel");
		}
	},
	components: {
		AppButton,
		AppSection
	},
	i18nEx: {
		componentPrefix: "views.TheLogin"
	}
});
